import Vuex from 'vuex';
import Vue from 'vue';

import productStore from 'vue/stores/products';
import mechanical from 'vue/stores/mechanical';
import vepCalculator from 'vue/stores/vep-calculator';

/* Version 1 */
import seismicSystem from 'vue/stores/seismic-system';
import seismicPipes from 'vue/stores/seismic-pipes';
import seismicAttachment from 'vue/stores/seismic-attachment';
import seismicBraceConfiguration from 'vue/stores/seismic-brace-configuration';

/* Version 2 */
import submittalSystem from 'vue/stores/submittal-system';
import submittalPipes from 'vue/stores/submittal-pipes';
import submittalStandards from 'vue/stores/submittal-standards';
import submittalAttachment from 'vue/stores/submittal-attachment';

import { vuexModule as ClockvineStore } from 'clockvine-vue';

Vue.use(Vuex);

let getUrl = function(action, params) {
    let url = this.indexUrl(action, params);

    if (action == 'index' || action == 'store' || action == 'update') {
        return `${url}/${action}`;
    } else if (params.record) {
        return `${url}/${action}?id=${params.record['id']}`;
    } else {
        return `${url}/${action}?id=${params['id']}`;
    }
};

/*
BEGIN Seismic v1 code (Anvil Plugin)
*/
let seismicDesign = new ClockvineStore('/actions/anvil-module/seismic-design');
let seismicContact = new ClockvineStore('/actions/anvil-module/seismic-contact'); // Don't think this is used any more
let seismicDesignContact = new ClockvineStore('/actions/anvil-module/seismic-design-contact');
let seismicDesignBraceConfiguration = new ClockvineStore('/actions/anvil-module/seismic-design-brace-configuration');

seismicDesign.getUrl = getUrl;
seismicContact.getUrl = getUrl;
seismicBraceConfiguration.getUrl = getUrl; // Overloaded below?

let getSeismicDesignFilteredUrl = function(action, params) {
    let url = this.indexUrl(action, params);

    if (action == 'index' || action == 'store' || action == 'update') {
        return `${url}/${action}?seismicDesignId=${params.seismicDesignId}`;
    } else if (params.record) {
        return `${url}/${action}?id=${params.record['id']}`;
    } else {
        return `${url}/${action}?id=${params['id']}`;
    }
};

seismicDesignContact.getUrl  = getSeismicDesignFilteredUrl;
seismicDesignBraceConfiguration.getUrl = getSeismicDesignFilteredUrl;
seismicBraceConfiguration.getUrl = getSeismicDesignFilteredUrl;

/*
END Seismic v1 code (Anvil Plugin)

BEGIN Seismic v2 code (SeismicSubmittal Plugin)
*/
let submittalDesign = new ClockvineStore('/actions/seismic-submittal/design');
let submittalContact = new ClockvineStore('/actions/seismic-submittal/contact');
let submittalBrace = new ClockvineStore('/actions/seismic-submittal/brace');

let getSubmittalDesignFilteredUrl = function(action, params) {
    let url = this.indexUrl(action, params);

    if (action == 'index' || action == 'store' || action == 'update') {
        return `${url}/${action}?designId=${params.designId}`;
    } else if (params.record) {
        return `${url}/${action}?id=${params.record['id']}`;
    } else {
        return `${url}/${action}?id=${params['id']}`;
    }
};

submittalDesign.getUrl = getUrl;
submittalContact.getUrl = getSubmittalDesignFilteredUrl;

// Developer note: Not sure why but version 1 has 2 BraceConfiguration elements with getUrl functions attached
// They are clockvine stores attached to the same database table via different Anvil plugin endpoints (one applies design filters)
submittalBrace.getUrl = getSubmittalDesignFilteredUrl;

/*
END Seismic v2 code (SeismicSubmittal Plugin)
*/

const store = new Vuex.Store({
    modules: {
        mechanical,
        productStore,
        seismicSystem,
        seismicPipes,
        seismicAttachment,
        seismicDesign,
        seismicContact, // I don't think this is used any more
        seismicDesignContact,
        seismicBraceConfiguration,
        seismicDesignBraceConfiguration,
        submittalAttachment,
        submittalSystem,
        submittalPipes,
        submittalDesign,
        submittalContact,
        submittalBrace,
        submittalStandards,
        vepCalculator,
    },
});

window.$store = store;

export {store, Vuex};
